import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import {Entitlement, Modules} from './entitlement.model';
import {environment} from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class EntitlementApiService {
  readonly API_URL = environment.entitlement_url;

  constructor(private http: HttpClient) { }

  getEntitlements() {
    return this.http.get<Entitlement[]>(`${this.API_URL}/entitlements?clientId=3010000024`);
  }

  searchEntitlements(clientId: string): Observable<Entitlement | Modules[]> {
    if (!clientId || !clientId.trim()) {return of();
    }
    return this.http.get<Entitlement>(`${this.API_URL}/entitlements?clientId=${clientId}`, httpOptions).pipe(
      map(entitlement => entitlement.modules),
      tap(_ => this.log(`found Entitlements matching "${clientId}"`)),
      catchError(this.handleError<Entitlement>('searchEntitlements'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/entitlement/entitlement.service.ts